import { useDataPrefetchStatus } from './DataPrefetchProvider';
import { Progress } from './ui/progress';
import { Loader2 } from 'lucide-react';

/**
 * Indicador visual de pré-carregamento de dados
 * Mostra apenas durante carregamento inicial e desaparece quando completo
 */
export const PrefetchLoadingIndicator = () => {
  const { isLoading, progress } = useDataPrefetchStatus();

  if (!isLoading) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-sm">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center gap-3">
          <Loader2 className="h-4 w-4 animate-spin text-primary" />
          <div className="flex-1">
            <Progress value={progress} className="h-1" />
          </div>
          <span className="text-sm text-muted-foreground">
            {progress}%
          </span>
        </div>
      </div>
    </div>
  );
};
